<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <DrugTabLinks />

                    <div class="flex items-center mt-4">
                        <div class="w-1/4">
                            <CSelect
                                class="mb-0"
                                horizontal
                                :value.sync="selectedCategoryId"
                                :options="filteredCategories"
                                placeholder="Выберите категорию..." />
                        </div>

                        <CButton
                            :color="selectedCategoryId ? 'primary' : 'secondary'"
                            :class="{ 'cursor-not-allowed': !selectedCategoryId }"
                            class="ml-6"
                            @click="onAddCategory(selectedCategoryId)">Добавить</CButton>
                    </div>

                    <Draggable
                        v-model="categories"
                        tag="div"
                        class="mt-4">
                        <div
                            v-for="item in categories"
                            :key="item.id"
                            class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-1/4">
                                <CIcon
                                    :height="24"
                                    :content="cilCursorMove"
                                    class="handle" />
                            </div>

                            <div class="w-2/4">{{ item.title }}</div>

                            <div class="w-1/4">
                                <CButton @click="removeCategory(item.id)">
                                    <CIcon
                                        :height="12"
                                        :content="cilTrash"
                                        class="handle" />
                                </CButton>
                            </div>
                        </div>
                    </Draggable>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" @click="submit">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';
    import Draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';
    import DrugTabLinks from '@/components/pharmacies/DrugTabLinks';

    export default {
        components: {
            Draggable,
            DrugTabLinks,
        },

        data: () => ({
            cilCursorMove,
            cilTrash,
            entity: undefined,
            selectedCategoryId: null,
            categories: [],
            allCategories: [],
        }),

        computed: {
            filteredCategories() {
                if (Array.isArray(this.categories)) {
                    const categoriesIdList = this.categories.map(item => item.id);
                    return this.allCategories.filter(
                        item => !categoriesIdList.includes(item.id)
                    );
                }

                return this.allCategories;
            },
        },

        async created() {
            await Promise.all([this.fetchEntity(), this.fetchCategories()]);
        },

        methods: {
            async fetchEntity() {
                const { id, drug_id } = this.$route.params;

                const [error, result] = await to(
                    this.axios.get(`/pharmacies/${id}/drugs/${drug_id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении лекарства. ' + error);
                }

                this.entity = result.data;

                this.categories = result.data.categories.map(item => ({
                    ...item,
                    label: item.title,
                    value: item.id,
                }));
            },

            async fetchCategories() {
                const { id, drug_id } = this.$route.params;
                const [error, result] = await to(
                    this.axios.get(`/pharmacies/${id}/categories`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении категорий аптеки. ' + error);
                }

                this.allCategories = result.data.map(item => ({
                    ...item,
                    enabled: Boolean(item.enabled),
                    empty: Boolean(item.empty),
                    label: item.title,
                    value: item.id,
                }));
            },

            async submit() {
                const { id, drug_id } = this.$route.params;

                const categories = this.categories.map((item, idx) => ({
                    id: item.id,
                    position: idx + 1,
                }));

                const [error] = await to(
                    this.axios.post(
                        `/pharmacies/${id}/drugs/${drug_id}/categories`,
                        { categories }
                    )
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при сохранении категорий. ' + error);
                } else {
                    this.$router.push(`/pharmacies/${id}/drugs/${drug_id}`);
                }
            },

            onAddCategory(id) {
                if (!id) {
                    return false;
                }

                const category = this.filteredCategories.find(
                    item => item.id === id
                );

                if (category) {
                    this.categories.push({
                        id: category.id,
                        title: category.title,
                    });
                    this.selectedCategoryId = null;
                }
            },

            removeCategory(id) {
                const idx = this.categories.findIndex(item => item.id === id);

                if (idx === -1) {
                    return false;
                }

                this.categories.splice(idx, 1);
            },
        },
    };
</script>
